import { render, staticRenderFns } from "./formCurriculum.vue?vue&type=template&id=5e248b6a&scoped=true&"
import script from "./formCurriculum.vue?vue&type=script&lang=js&"
export * from "./formCurriculum.vue?vue&type=script&lang=js&"
import style0 from "./formCurriculum.vue?vue&type=style&index=0&id=5e248b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e248b6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VAutocomplete,VFlex,VLayout,VRadio,VRadioGroup})
